var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.settings.isPro ? 'pointer-events-none' : 'cursor-pointer',on:{"click":_vm.handleUpgrade}},[_c('div',{staticClass:"px-2 font-bold text-white rounded-xl uppercase",class:[
      _vm.isWhite ? 'border-white border' : 'gradient',
      _vm.isSmall ? '' : 'py-1',
      _vm.isHail ? '' : '',
    ],style:([_vm.isSmall ? { fontSize: '8px' } : { fontSize: '10px' }])},[(!_vm.isHail)?_c('span',[_vm._v(" Pro ")]):_c('span',{},[_vm._v("\n      Hail\n      ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }